import { AnimatedLogoMark } from "#/components/logo";

/** Router-level `defaultPendingComponent` — shown in place of a route's
 * content once it's taken longer than the router's pendingMs to resolve
 * (see src/router.tsx), so a slow loader/beforeLoad never just freezes the
 * previous page with no feedback. */
export function LoadingScreen() {
	return (
		<div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-canvas py-24">
			<AnimatedLogoMark mode="loop" className="h-14 w-auto" />
		</div>
	);
}
